import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

const CheckboxButton = styled.label`
  width: calc(50% - 5px);
  position: relative;
  margin-bottom: 7px;
  cursor: pointer;
  align-self: center;
  text-align: center;
  height: 40px;
  font-size: 14px;
  line-height: 40px;

  :nth-child(odd) {
    margin-right: 5px;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    display: block;
    border: 1px solid ${themeGet("colors.EYOffBlack.default")};
    height: 40px;
  }

  &:hover {
    background-color: ${themeGet("colors.EYYellow.hover")};
  }

  &:hover input ~ span {
  }

  & input:checked ~ span {
    background: ${themeGet("colors.EYOffBlack.default")};
    color: ${themeGet("colors.EYOffWhite")};
  }
`;

export default CheckboxButton;
